import { render, staticRenderFns } from "./instrucoes.vue?vue&type=template&id=6ed87544&scoped=true"
import script from "./instrucoes.vue?vue&type=script&lang=js"
export * from "./instrucoes.vue?vue&type=script&lang=js"
import style0 from "./instrucoes.vue?vue&type=style&index=0&id=6ed87544&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed87544",
  null
  
)

export default component.exports